<template>
    <div class="personal-details">
        <div class="personal-details__personal-title">
            Personal Details
        </div>
        <div class="personal-details__all-details">
            <!-- <div class="user-input small-verified-input"> -->
            <div class="small-verified-all">
                <verified-icon class="small-verified-icon"></verified-icon>
                <div class="small-verified">
                    Verified Creator:
                </div>

                <div class="small-verification">Yes</div>
                <div class="small-edit">
                    <router-link
                        :to="{
                            name: MY_ACCOUNT_DETAILS_PAGE_NAME,
                        }"
                    >
                        <edit-pen class="small-edit" />
                    </router-link>
                </div>
            </div>
            <!-- </div> -->

            <div class="user-personal-details username-verified">
                <div class="detail-title">Username</div>
                <div class="user-input verified-input">
                    <div v-if="userinfo.username" class="username-data">
                        {{ userinfo.username }}
                    </div>

                    <div class="verified-all">
                        <verified-icon class="verified-icon"></verified-icon>
                        <div class="verified">
                            <span>Verified Creator:</span>
                        </div>

                        <div class="verification">Yes</div>
                        <div class="edit">
                            <router-link
                                :to="{
                                    name: MY_ACCOUNT_DETAILS_PAGE_NAME,
                                }"
                            >
                                <edit-pen class="edit" />
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="getCreator.firstName != null"
                class="user-personal-details"
            >
                <div class="detail-title">
                    Name
                </div>

                <div class="user-input">{{ getCreator.firstName }}</div>
            </div>

            <div
                v-if="getCreator.lastName != null"
                class="user-personal-details"
            >
                <div class="detail-title">Surname</div>

                <div class="user-input">
                    {{ getCreator.lastName }}
                </div>
            </div>

            <div
                v-if="getCreator.countryCode != null"
                class="user-personal-details"
            >
                <div class="detail-title">
                    Country
                </div>

                <div class="user-input">
                    {{ codeLocation }}
                </div>
            </div>

            <div class="user-personal-details">
                <div class="detail-title">E-mail</div>

                <div
                    v-if="userinfo.email && !getCreator.mail"
                    :title="userinfo.email"
                    class="user-input"
                >
                    {{ userinfo.email }}
                </div>
                <div
                    v-if="getCreator.mail"
                    :title="getCreator.mail"
                    class="user-input"
                >
                    {{ croppName(getCreator.mail, 15) }}
                </div>
            </div>
            <div class="user-personal-details profile">
                <div class="detail-title">
                    Profile Picture:
                </div>
                <div class="user-input avatar-all">
                    <img
                        v-if="userinfo.avatars"
                        :src="userinfo.avatars.default.url"
                        class="avatar text-around"
                    />
                    <UserOutIcon
                        v-else
                        width="60"
                        fill="#0a294a"
                        class="avatar text-around"
                    />
                    <div class="avatar-description" asdf>
                        Upload a photo or select an avatar.
                    </div>
                    <div class="change-button">
                        <picture-button
                            :color="'veryDarkBlue'"
                            :link="'https://accounts.bistudio.com/profile/user'"
                            :text="'Change Picture'"
                            :outside="true"
                            class="picture-button"
                            :width-static="'190px'"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/common/Button';
import User from '@/services/user';
import { MY_ACCOUNT_DETAILS_PAGE_NAME } from '@/router/pageNameConstants.js';
import locations from '@/assets/data/country-codes.json';
import { croppName } from '@/lib/croppName.js';
import { mapGetters, mapActions } from 'vuex';

//SVG
import UserOutIcon from 'Svgs/user_out.svg?inline';
import VerifiedIcon from 'Svgs/verified_badge.svg?inline';
import EditPen from 'Svgs/edit-pen.svg?inline';

export default {
    name: 'PersonalDetails',
    components: {
        VerifiedIcon,
        UserOutIcon,
        'edit-pen': EditPen,
        'picture-button': Button,
    },
    data() {
        return {
            MY_ACCOUNT_DETAILS_PAGE_NAME,
            userinfo: '',
            locations,
            codeLocation: null,
        };
    },
    computed: {
        ...mapGetters('creator', {
            getCreator: 'getCreator',
        }),
    },
    async mounted() {
        await this.getUserInfo();
        await this.fetchCreator();
        await this.getLocation();
    },

    methods: {
        ...mapActions('creator', ['fetchCreator']),
        getLocation() {
            if (this.getCreator.countryCode) {
                const codeLocation = this.locations.find(
                    item => item.value === this.getCreator.countryCode
                );

                return codeLocation
                    ? (this.codeLocation = codeLocation.label)
                    : (this.codeLocation = '');
            }
        },
        getUserInfo() {
            User.getUser()
                .then(response => {
                    this.userinfo = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        croppName,
    },
};
</script>

<style scoped lang="scss">
.personal-details {
    display: flex;
    flex-direction: column;
    margin: 0 3rem 280px 3rem;
    @media (max-width: $xs-up) {
        margin: 0 2rem 0 2rem;
    }

    &__personal-title {
        color: $blue-main;
        font-family: $istok-font;
        font-size: 29px;
        font-weight: 700;
        letter-spacing: 0.46px;
        line-height: 53px;
    }

    &__all-details {
        display: flex;
        flex-direction: column;
        padding: 2%;
        border-radius: 6px;
        border: 1px solid $blue-main;

        .small-verified-all {
            display: none;
            @media (max-width: 575px) {
                margin: 0;
                display: flex;
                align-items: center;
                padding-left: 2%;
            }

            .small-verification {
                padding-right: 2%;
                margin: 0 auto 0 0;
            }

            .small-verified-icon {
                margin: auto 5px auto 0;
            }
            .small-verified {
                @include personal-details-col-two;
                flex: 0.5;
                font-size: 18px;

                @media (max-width: 494px) {
                    flex: 0.6;
                }

                @media (max-width: 411px) {
                    flex: 0.7;
                }
                @media (max-width: 375px) {
                    flex: 0.8;
                }
                @media (max-width: 347px) {
                    flex: 0.9;
                }

                @media (max-width: $xxs-up) {
                    flex: 1;
                }
            }
            a {
                display: flex;
            }

            .small-edit {
                justify-self: center;
                width: 30px;
                height: 15px;
                cursor: pointer;
                align-self: center;
                margin-left: 8px;
            }
        }

        .username-verified {
            display: flex;

            .verified-input {
                display: flex;
                justify-content: space-between;

                .username-data {
                    flex: 0.5;

                    @media (max-width: $xs-up) {
                        flex: 1;
                    }
                }

                .verified-all {
                    display: none;

                    @media (min-width: 576px) {
                        display: flex;
                    }

                    .verified {
                        @include personal-details-col-two;
                        flex: 0.5;
                        font-size: 22px;
                        margin-right: 5px;

                        @media (min-width: 576px) and (max-width: $sm-up) {
                            font-size: 18px;
                        }
                    }

                    .verification {
                        padding-right: 15px;
                        font-size: 22px;

                        @media (min-width: 576px) and (max-width: $sm-up) {
                            font-size: 18px;
                        }
                    }

                    .verified-icon {
                        margin-top: 5px;
                        margin-right: 15px;
                    }

                    a {
                        display: flex;
                    }

                    .edit {
                        justify-self: center;
                        width: 18px;
                        height: 22px;
                        cursor: pointer;

                        @media (min-width: 576px) and (max-width: $sm-up) {
                            width: 16px;
                            height: 20px;
                        }
                    }
                }
            }
        }
        .user-personal-details {
            display: flex;
            padding: 2% 0;

            @media (max-width: $xs-up) {
                flex-direction: column;
            }

            .detail-title {
                flex: 1;
                align-self: center;
                @include biggerText;
                white-space: nowrap;

                @media (max-width: 767px) {
                    align-self: unset;
                }

                @media (max-width: $xs-up) {
                    padding-bottom: 2%;
                }
                @media (max-width: $sm-up) {
                    font-size: 20px;
                }
            }

            .user-input {
                display: flex;
                flex: 3;
                color: $blue-main;
                font-size: 20px;
                color: #0a294a;
                font-family: 'Istok Web';
                font-size: 22px;
                font-weight: 700;
                line-height: 30px;
                white-space: nowrap;

                @media (max-width: $sm-up) {
                    font-size: 18px;
                }
            }
        }

        .profile {
            border-top: 1px solid black;
            display: flex;
            .detail-title {
                align-self: center;
                @media (max-width: 884px) {
                    font-size: 19px;
                    flex: 0.9;
                }
            }

            @media (max-width: 700px) {
                flex-direction: column;
            }

            .avatar-all {
                display: flex;

                @media (max-width: 572px) {
                    flex-direction: column;
                }

                .avatar {
                    @media (max-width: 900px) {
                        width: 8vw;
                    }

                    @media (max-width: 572px) {
                        margin: 0 auto;
                        width: 30%;
                    }
                }

                .avatar-description {
                    font-family: $istok-font;
                    color: #979797;
                    padding: 2%;
                    font-size: 18px;
                    font-weight: 400;
                    line-height: 25px;
                    align-self: center;
                    @media (max-width: 572px) {
                        text-align: center;
                    }

                    @media (max-width: 840px) {
                        font-size: 16px;
                        padding-left: 2%;
                    }
                }

                .change-button {
                    margin: auto 0 auto auto;

                    @media (max-width: 572px) {
                        margin: 0 auto;
                    }
                }
            }
        }
    }
}
</style>
<style lang="scss">
.change-button {
    .picture-button {
        @media (max-width: 892px) {
            width: 170px !important;
        }

        @media (min-width: 573px) and (max-width: 800px) {
            width: 140px !important;
        }

        @media (max-width: 572px) {
            width: 230px !important;
        }
    }

    .button-text {
        @media (max-width: 800px) {
            font-size: 12px;
        }
    }
}
</style>
